import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default class SliderCollection {
	constructor(sliderElement) {

        this.breakpoint = window.matchMedia('(max-width:820px)');
        const nextButton = document.querySelector('.swiper-button-next');
        const prevButton = document.querySelector('.swiper-button-prev');

        const options = {
            direction: 'horizontal',
            slidesPerView: 2.5,
            lazy: true,
            modules: [Navigation],

            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },

            breakpoints: {
				768: {
					slidesPerView: 2.5,
                    spaceBetween: 40,
				},
				1080: {
					slidesPerView: 3.8,
                    spaceBetween: 60,
				},
			},
        };

        this.swiper = new Swiper(sliderElement, options);

        if ( this.breakpoint.matches === true ) {

            this.swiper.destroy( true, true );
            return;
        }
	}
}
